import { Route } from "@angular/router";
import { DeliveryComponent } from "./delivery.component";
import { DeliveryListRouting } from "./delivery-list/delivery-list-routing";
import { DeliveryScheduleRouting } from "./delivery-schedule/delivery-schedule-routing";
import { DeliveryDetailsRouting } from "./delivery-details/delivery-details-routing";
import { Permissions } from "../../access/shared/authorization/permissions";

export const DeliveryRouting: Route = {
    path: 'delivery', component: DeliveryComponent,
    children: [
        { path: '', redirectTo: 'list', pathMatch: 'prefix' },
        DeliveryListRouting,
        DeliveryScheduleRouting,
        DeliveryDetailsRouting,
    ],
    data: {
        breadcrumb: "Livraison",
        'role': [
            Permissions.ROLE_LIVRAISON,
        ],
    }
};
